import axios from 'axios';
import { userCartoonsAction } from './UserCartoonsSlice';

const getUserCartoons = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/cartoons`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(userCartoonsAction.userCartoonsSuccess(result.data));
      return result.data;
    } catch (e) {
      dispatch(userCartoonsAction.userCartoonsFailure(e.response?.data ?? e.message));
      return null
    }
  };
};

export default getUserCartoons;